import React from "react";
import "../css/ContactMap.css";

const ContactMap = () => {
  return (
    <div className="map-container">
      <iframe 
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3804.9021461167367!2d78.37233957594168!3d17.512183999196516!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb93be4f4cd87b%3A0x51cd561c7de9baf7!2sRoyal%20Wave%20Biotech%20(Dr.Chek)!5e0!3m2!1sen!2sin!4v1741426496716!5m2!1sen!2sin" 
        width="100%" 
        height="100%" 
        style={{ border: "0" }} 
        allowFullScreen="" 
        loading="lazy" 
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  );
};

export default ContactMap;